import {
	fetchUserRecommendations,
	TeamSearchField,
	type UserSearchItem,
} from '@atlaskit/smart-common';

import { PrimaryProductKeys } from '../../../common/constants/primary-product-keys';
import { type onError } from '../../error-boundary/log-exception';

export type FetchPeopleAndTeamsParams = {
	primaryProduct: string | undefined;
	cloudId: string | undefined;
	userId: string | undefined;
	orgId: string | undefined;
};

export const fetchPeopleAndTeamsResults = (
	query: string,
	params: FetchPeopleAndTeamsParams,
	onError: onError,
): Promise<{
	results: never[] | UserSearchItem[];
	duration: number;
}> => {
	const fetchData = async (query: string) => {
		performance.mark('fetchPeopleAndTeamsResultsStart');

		// Map townsquare scope as URS does not support townsquare as a primary product
		const productKey =
			params.primaryProduct === PrimaryProductKeys.Atlas ? 'people' : params.primaryProduct;

		const recommendations = await fetchUserRecommendations({
			query,
			context: {
				contextType: 'full_page_search',
				siteId: params.cloudId || '',
				productKey: productKey || '',
				principalId: params.userId || '',
				organizationId: params.orgId || '',
			},
			includeUsers: true,
			includeTeams: true,
			includeGroups: false,
			maxNumberOfResults: 3,
			performSearchQueryOnly: false,
			searchQuery: {
				filter:
					'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)',
				teamSearchFields: [TeamSearchField.NAME],
			},
		}).catch((error) => {
			onError(error);
			return [];
		});

		performance.mark('fetchPeopleAndTeamsResultsEnd');

		const { duration } = performance.measure(
			'fetchPeopleAndTeamsResultsDuration',
			'fetchPeopleAndTeamsResultsStart',
			'fetchPeopleAndTeamsResultsEnd',
		);

		return {
			results: recommendations,
			duration,
		};
	};

	return fetchData(query);
};
